import { useEffect } from 'react';
import { useHistory } from 'react-router';

export default function useViewReset(): void {
  // Scroll to the top of the page each time the page changes; otherwise for long
  // pages/short screens, the next page will load scrolled to the bottom.
  const history = useHistory();
  useEffect(() => {
    const unlisten = history.listen((): void => {
      if (history.action !== 'REPLACE') window.scrollTo(0, 0);
    });
    return (): void => unlisten();
  }, [history]);
}
